import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert,Box, Button, Divider, Link, Typography, LinearProgress} from "@mui/material";
import { useState } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SavingsDetails from '../components/SavingsDetails';
import LoansDetails from '../components/LoansDetails';
import SharesDetails from '../components/SharesDetails';
import CommodityDetails from '../components/CommodityDetails';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CreateSavingsNon from '../components/CreateSavingsNon';
import CreateLoansNon from '../components/CreateLoansNon';
import CreateSharesNon from '../components/CreateSharesNon';
import CreateCommoditiesNon from '../components/CreateCommoditiesNon';

export default function UnregisteredPassBook() {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const location = useLocation();
    const ID = location.state && location.state.Member_id;
    const Name = location.state && location.state.Fullname;
    const [accounts, setAccounts] = useState({});
    const [open_acc, setOpen_acc] = useState();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [ope, setOpe] = React.useState(false);
    const [message, setMessage] = useState("");
    const open = Boolean(anchorEl);
    const [saveValue, setSaveValue] = useState(0)
    const [loanValue, setLoanValue] = useState(0);
    const [shareValue, setShareValue] = useState(0);
    // const [commodityValue, setCommodityValue] = useState(0);
    const [passbookValue, setPassbookValue] = useState(0) 
    const [alert, setAlert] = useState()


    useEffect(() => {
        if (accounts.Savings_acc) {
          let totalSavingsValue = 0;
          accounts.Savings_acc.forEach((savingsItem) => {
            totalSavingsValue += savingsItem.Current_Balance;
          });
          setSaveValue(totalSavingsValue);
        }
      }, [accounts.Savings_acc])
    
        useEffect(() => {
          if (accounts.Loans_acc) {
            let totalLoanValue = 0;
            accounts.Loans_acc.forEach((loanItem) => {
              totalLoanValue += loanItem.current_balance;
            });
            setLoanValue(totalLoanValue);
          }
        }, [accounts.Loans_acc]);
        
    
        useEffect(() => {
          if (accounts.Shares_acc) {
            let totalShareValue = 0;
            accounts.Shares_acc.forEach((shareItem) => {
              totalShareValue += shareItem.current_balance;
            });
            setShareValue(totalShareValue);
          }
        }, [accounts.Shares_acc]); 
        
        // useEffect(() => {
        //   if (accounts.Commodity_acc) {
        //     let totalCommodityValue = 0;
        //     accounts.Commodity_acc.forEach((commodityItem) => {
        //       totalCommodityValue += commodityItem.Amount_value;
        //     });
        //     setCommodityValue(totalCommodityValue);
        //   }
        // }, [accounts.Commodity_acc]); 
    
        useEffect(() => {
          setPassbookValue(
            saveValue + shareValue  + loanValue
          ) 
        }, [saveValue],  [shareValue], [loanValue])



    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    useEffect(() => {
        const fetchAccounts = async () => {
            try{
              const response = await api.get(`/account/account/${ID}`,{
                headers: {
                  Authorization: 'Bearer '+ fetchToken()
                }
              })
                setAccounts(response.data)

            }catch (error){
              console.log('Here is the error '+error)
            }
        }
        fetchAccounts()
    }, [])

    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    }));

    const handleSave = (id,name) => {
      if (open_acc == null)
      {
        setOpen_acc(<SavingsDetails ID= {id} name={name} setOpen_acc={setOpen_acc}/>)
        setAlert()
      }else{
        setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
      }
    }

    const handleLoan = (id,name) => {
      if (open_acc == null)
      {
        setOpen_acc(<LoansDetails ID={id} name={name} setOpen_acc={setOpen_acc}/>)
        setAlert()
      }else{
        setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
      }
    }

    const handleShare = (id,name) => {
      if (open_acc == null)
      {
        setOpen_acc(<SharesDetails name={name} ID={id} setOpen_acc={setOpen_acc}/>)
        setAlert()
      }else{
        setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
      }
    }

    // const handleCommodity = (id,name) => {
    //   if (open_acc == null)
    //   {
    //     setOpen_acc(<CommodityDetails name={name} ID={id} setOpen_acc={setOpen_acc}/>)
    //     setAlert()
    //   }else{
    //     setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
    //   }
    // }


    const handleNewSavings = () => {
      setOpen_acc(<CreateSavingsNon member_id={ID}/>)
    };

    const handleNewLoans = () => {
      setOpen_acc(<CreateLoansNon member_id={ID}/>)
    };

    const handleNewShares = () => {
      setOpen_acc(<CreateSharesNon member_id={ID}/>)
    };

    const handleNewCommoddities = () => {
      setOpen_acc(<CreateCommoditiesNon member_id={ID}/>)
    };

  return (
      <div className="app">
        <main className="content">
            <Box sx={{ m:5 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Passbook" subtitle="Accounts and details" />
              </Box>
              {
                accounts !== null
                ?
                <Grid container spacing={2}>
              {/* name of member and maybe the passbook number as header here */}
              <Grid item xs={12} md={12}>
                <Item>
                  <Typography variant='h3'>{`${Name}'s Passbook`}</Typography>
                </Item>
              </Grid>
              <Divider sx={{ mb: '10px', mt:'10px' }} variant='middle' />
                {/* accounts and accounts info will also be here */}
              <Grid container spacing={1} sx={{ marginLeft: '10px' }}>
                {/* All account names and total balances will be here */}
                <Grid item xs={12}>

                  <Button
                    variant='contained'
                    id="demo-positioned-button"
                    aria-controls={open ? 'demo-positioned-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                  >
                  Open new Account
                  </Button>
                  <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <MenuItem onClick={handleNewSavings}>Savings Account</MenuItem>
                    <MenuItem onClick={handleNewLoans}>Loans Account</MenuItem>
                    <MenuItem onClick={handleNewShares}>Shares Account</MenuItem>
                    <MenuItem onClick={handleNewCommoddities}>Commodities Account</MenuItem>
                    <MenuItem onClick={handleClose}>Cancel</MenuItem>
                  </Menu>
                </Grid>
              <Grid item xs={12} md={4}>
                <>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    display='flex'
                  >
                    <Typography sx={{ mr: '59px' }}>Savings Accounts</Typography>
                    <Typography sx={{ fontWeight:'700' }}>Total Balance: GH₵{saveValue}.00</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Divider variant='middle' sx={{ mb: '3px' }} />
                  {accounts.Savings_acc?.map((savingsItem, index) => (
                      <Link
                          sx={{ display:'flex' }}
                          key={index}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleSave(savingsItem.ID, savingsItem.Account_Name)}
                      >
                          <Typography sx={{ fontWeight:'600'}}>{savingsItem.Account_Name}</Typography>
                          <Typography sx={{ fontWeight:'600', ml:'55px' }}>GH₵{savingsItem.Current_Balance}.00</Typography>
                          <Divider variant='middle' sx={{marginBottom:'10px'}} />
                      </Link>
                      
                  ))}
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    display='flex'
                  >
                    <Typography sx={{ mr: '59px' }}>Loans Accounts</Typography>
                    <Typography sx={{ fontWeight:'700' }}>Total Balance: GH₵{loanValue}.00</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Divider variant='middle' />
                  {accounts.Loans_acc?.map((savingsItem, index) => (
                      <Link
                          sx={{ display:'flex' }}
                          key={index}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleLoan(savingsItem.ID, savingsItem.account_name)}
                      >
                          
                          <Typography sx={{ fontWeight:'600'}}>{savingsItem.account_name}</Typography>
                          <Typography sx={{ fontWeight:'600', ml:'55px' }}>GH₵{savingsItem.current_balance}.00</Typography>
                      </Link>
                      
                  ))}
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel3a-header"
                    display='flex'
                  >
                    <Typography sx={{ mr: '59px' }}>Share Accounts</Typography>
                    <Typography sx={{ fontWeight:'700' }}>Total Balance: GH₵{shareValue}.00</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Divider variant='middle' />
                  {accounts.Shares_acc?.map((savingsItem, index) => (
                      <Link
                          sx={{ display:'flex' }}
                          key={index}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleShare(savingsItem.ID, savingsItem.account_name)}
                      >
                          
                          <Typography sx={{ fontWeight:'600'}}>{savingsItem.account_name}</Typography>
                          <Typography sx={{ fontWeight:'600', ml:'55px' }}>GH₵{savingsItem.current_balance}.00</Typography>
                      </Link>
                  ))}
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    display='flex'
                  >
                    <Typography sx={{ mr: '59px' }}>Commodity Accounts</Typography>
                    {/* <Typography sx={{ fontWeight:'700' }}>Total Balance: GH₵{commodityValue}.00</Typography> */}
                  </AccordionSummary>
                  <AccordionDetails>
                    <Divider variant='middle' />
                  {/* {accounts.Commodity_acc?.map((savingsItem, index) => (
                      <Link
                          sx={{ display:'flex' }}
                          key={index}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleCommodity(savingsItem.ID, savingsItem.Warehouse_name)}
                      >
                          
                          <Typography sx={{ fontWeight:'600'}}>{savingsItem.Warehouse_name}</Typography>
                          <Typography sx={{ fontWeight:'600', ml:'55px' }}>Amount of Commodities:{savingsItem.Amt_of_Commodity}</Typography>
                      </Link>
                  ))} */}
                  </AccordionDetails>
                </Accordion>
                <p>Passbook Value: <Typography sx={{ fontWeight:'600'}}>GH₵{passbookValue}.00 </Typography>(SaA + ShA + CoA - LoA)</p>

                </>
              </Grid>
              {/* here for account's recent transaction when clicked */}
              <Grid item xs={12} md={8}>
                  {open_acc}
              </Grid>

              </Grid>

              </Grid>
              :
              <Box sx={{ width: '100%' }}>
                <LinearProgress />
              </Box>
              }
            </Box>
          </main>
            </div>
  );
};
